// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3l383","clinicsSelect":"styles_clinicsSelect__itf_Q"};